import * as React from "react";
import { debounce } from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import { Paper, InputBase, IconButton } from "@mui/material";
import { colors } from "../pages/css components/Style";

export default function Search({ setPage, setSearchKey }) {
  const handleSearchDebounce = React.useMemo(
    () =>
      debounce((val) => {
        setPage((prev) => ({
          ...prev,
          page: 1,
        })); // reset to first page on new search
        setSearchKey(val);
      }, 300),
    []
  );

  const handleSearchChange = (e) => {
    handleSearchDebounce(e.target.value);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        alignItems: "center",
        width: "inherit",
        height: "30px",
        borderRadius: "4px",
        justifyContent: "space-between",
        boxShadow: "#eaeaea 0px 0px 0px 1px",
      }}
    >
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon
          sx={{
            color: colors.text,
            mixBlendMode: "normal",
            opacity: 0.8,
          }}
        />
      </IconButton>
      <InputBase
        fullWidth
        placeholder="Search"
        onChange={handleSearchChange}
        sx={{
          "& input::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: colors.text,
            mixBlendMode: "normal",
            opacity: 0.8,
          },
        }}
      />
    </Paper>
  );
}
